import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { FinancesGetByProjectIdProjectStatus, FinancesGetByProjectIdProjectStatusResponse, ProjectStatuses } from '../../api/dtos';

const getData = (response?: SWRResponse<FinancesGetByProjectIdProjectStatusResponse, FinancesGetByProjectIdProjectStatusResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<FinancesGetByProjectIdProjectStatusResponse, FinancesGetByProjectIdProjectStatusResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useFinances = (projectId?: number, projectStatus?: ProjectStatuses, configuration?: SWRConfiguration<FinancesGetByProjectIdProjectStatusResponse, FinancesGetByProjectIdProjectStatusResponse>) => {
    
    const request = useMemo(() => {
        return projectId != undefined ? () => {
                return new FinancesGetByProjectIdProjectStatus({
                    projectId: projectId,
                    projectStatus: projectStatus
                }) 
            }
            : undefined;
    }, [projectId, projectStatus])

    return useGet(request, { getData, getError }, configuration);
}

export default useFinances;